import { useState, useEffect } from 'react';
import { useHistoryStore } from '@/lib/store/history-store';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { HistoryItem } from '@/components/history/history-item';
import { SettingsList } from '@/components/settings/settings-list';
import { Search, Loader2 } from 'lucide-react';

export default function HistorySettingsPage() {
  const [activeTab, setActiveTab] = useState('history');
  const { searches, isLoadingSearches, loadSearchesFromFirestore } = useHistoryStore();

  useEffect(() => {
    document.title = 'History & Settings - Deepcheck';
    // Load searches from Firestore on mount
    loadSearchesFromFirestore();
  }, [loadSearchesFromFirestore]);

  return (
    <main className="px-4 py-6 space-y-6">
      {/* Title */}
      <h1 className="text-2xl font-bold text-gray-900">History & Settings</h1>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="history">History</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>

        <TabsContent value="history" className="mt-6">
          {isLoadingSearches ? (
            <div className="flex flex-col items-center justify-center py-16 text-center">
              <Loader2 className="w-12 h-12 text-gray-400 mb-3 animate-spin" />
              <p className="text-gray-600">Loading history...</p>
            </div>
          ) : searches.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16 text-center">
              <Search className="w-12 h-12 text-gray-400 mb-3" />
              <p className="text-gray-600">No history found</p>
            </div>
          ) : (
            <div className="space-y-3">
              {searches.map((search) => (
                <HistoryItem key={search.id} search={search} />
              ))}
            </div>
          )}
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          <SettingsList />
        </TabsContent>
      </Tabs>
    </main>
  );
}
